export default "__VITE_PUBLIC_ASSET__355455f1__"